<template>
  <div @click.prevent="onClick">
    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      publicKey: {
        type: String,
        default: ''
      },
      multiple: {
        type: Boolean,
        default: false
      },
      crop: {
        type: String,
        default: ''
      },
      tabs: {
        type: String,
        default: 'file url camera dropbox gdrive box skydrive'
      },
      inputAcceptTypes: {
        type: String,
        default: ''
      },
      preferredTypes: {
        type: String,
        default: ''
      },      
      previewStep: {
        type: Boolean,
        default: true
      },    
      systemDialog: {
        type: Boolean,
        default: false
      }            
    },
    beforeDestroy () {
      this.uploadcare = null
    },
    mounted () {
      this.uploadcare = import('uploadcare-widget') // eslint-disable-line
    },
    methods: {

      // TODO: Handle validators
      // https://uploadcare.com/docs/api_reference/javascript/file_validation/
      /*

      function imagesOnly(fileInfo) {
        if (fileInfo.isImage === false) {
          throw new Error('image');
        }
      }

      function maxDimensions(width, height) {
        return function(fileInfo) {
          var imageInfo = fileInfo.originalImageInfo;
          if (imageInfo !== null) {
            if (imageInfo.width > width || imageInfo.height > height) {
              throw new Error('dimensions');
            }
          }
        };
      }

      // It is better to use validators instead of checking file properties in widget.onChange and widget.onUploadComplete callbacks. Validators are activated before a dialog gets closed thus improving your UX.

      uploadcare.openDialog(null, {
        validators: [
          imagesOnly,
          maxSize(1024 * 1024),
          minDimensions(800, 600)
        ]
      });

      */

      openDialog () {
        this.uploadcare
          .then((uploadcare) => {
            this.dialog = uploadcare.openDialog(null, {
              publicKey: this.publicKey,
              multiple: this.multiple,
              crop: this.crop,
              tabs: this.tabs,
              systemDialog: this.systemDialog,
              previewStep: this.previewStep,
              inputAcceptTypes: this.inputAcceptTypes,
              preferredTypes: this.preferredTypes
            });    
            this.dialog.done((filePromise) => {
              // Dialog closed and a file or file group is selected.
              const promise = filePromise.promise();
              promise.done((result) => {
                console.log(result);
                this.$emit('success', result);
              })
              promise.fail((err) => {
                this.$emit('error', err)
              })
              promise.always(() => {
                // Handles a closing upload regardless of whether or not files were selected.
                // console.log('Promise (always) closed');
              });              
            });
            this.dialog.fail((err) => {
              // Dialog closed and no file or file group was selected.
              if (err) {
                this.$emit('error', err)
              }
            });
            this.dialog.always(() => {
              // Handles a closing dialog regardless of whether or not files were selected.
              // console.log('Dialog (always) closed');
            });              
          })
          .catch((err) => {
            this.$emit('error', err)
          })        
      },
      onClick () {
        this.openDialog();        
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vendor/Uploadcare.vue